import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import 'react-image-gallery/styles/css/image-gallery.css';
import ImageGallery from 'react-image-gallery';

const Carousel = ({ slice }) => {
    const images = slice.map(item => {
        return {
            original: item.image.url,
            thumbnail: item.image.thumbnail ? item.image.thumbnail.url : item.image.url
        };
    });

    return (
        <SCarousel>
            <ImageGallery items={images} lazyLoad={true} />
        </SCarousel>
    );
};

const SCarousel = styled.div`
    * + &,
    & + * {
        margin-top: 80px !important;
    }
`;
export default Carousel;

Carousel.propTypes = {
    slice: PropTypes.array.isRequired
};
